/* eslint-disable max-len */
import React from "react";

export default function iconHelp() {
  return (
    <svg
      className="icon help"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 50 50"
      version="1.1"
    >
      <g id="surface1">
        <path d="M 25 0 C 21.5 0 18.195313 1.292969 15.59375 3.59375 C 12.695313 6.195313 11 10 11 14 C 11 15.101563 11.898438 16 13 16 L 15 16 C 16.101563 16 17 15.101563 17 14 C 17 11.699219 17.988281 9.601563 19.6875 8 C 21.1875 6.699219 23 6 25 6 C 25.300781 6 25.605469 5.992188 25.90625 6.09375 C 29.605469 6.492188 32.507813 9.492188 32.90625 13.09375 C 33.304688 16.394531 31.585938 19.492188 28.6875 21.09375 C 24.488281 23.292969 21.90625 27.492188 21.90625 32.09375 L 21.90625 38 C 21.90625 39.101563 22.804688 40 23.90625 40 L 25.90625 40 C 27.007813 40 27.90625 39.101563 27.90625 38 L 27.90625 32.09375 C 27.90625 29.792969 29.300781 27.605469 31.5 26.40625 C 36.601563 23.707031 39.511719 18.199219 38.8125 12.5 C 38.210938 6 32.992188 0.792969 26.59375 0.09375 C 26.09375 -0.0078125 25.5 0 25 0 Z M 23 44 C 22.449219 44 22 44.445313 22 45 L 22 49 C 22 49.554688 22.449219 50 23 50 L 27 50 C 27.554688 50 28 49.554688 28 49 L 28 45 C 28 44.445313 27.554688 44 27 44 Z " />
      </g>
    </svg>
  );
}
